import { useCallback, useState } from 'react';
import moment from 'moment';

import jstz from 'jstimezonedetect';

import { httpGet } from '../../../../components/utils';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { ReportSettings } from '../types/RiskReport';
import { HttpResponse } from '../../../../api/types/Http';

interface ReportData {
    reportFileName: string | null;
    reportFileDate: string | null;
}

const useRiskReportGeneration = (onSuccess?: () => void) => {
    const [data, setData] = useState<ReportData>();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState<string>();

    const triggerRiskReportGeneration = useCallback(
        async (reportSettings: ReportSettings) => {
            setIsLoading(true);
            setIsSuccessful(false);
            setError(undefined);

            try {
                const localTimeZone = encodeURIComponent(jstz.determine().name());
                const endDate = reportSettings.endDate ?? moment();
                const duration = endDate.diff(reportSettings.startDate, 'days');

                const params = {
                    localTimeZone,
                    duration,
                    reportSettings
                };

                const response = (await httpGet('/insights/generateReportData', {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params
                    }
                })) as unknown as HttpResponse<ReportData>;
                setData(response.data);
                setIsSuccessful(true);
                onSuccess?.();
            } catch (err) {
                setError('Failed to generate risk report');
            }
        },
        [onSuccess]
    );

    return { mutate: triggerRiskReportGeneration, data, isLoading, isSuccessful, error };
};

export default useRiskReportGeneration;
